import React from 'react';
import { withRouter } from '@bingads-webui-campaign-react/router';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';

let previousRoute = '';
let previousSearch = '';
let urlChangeScenario;
let routeChangeLogger;
let paramChangeLogger;

const getUrlChangeScenario = (instrumentation) => {
  if (urlChangeScenario) {
    return urlChangeScenario;
  }

  urlChangeScenario = instrumentation.urlChange.create();
  return urlChangeScenario;
};

const getRouteChangeLogger = (instrumentation) => {
  if (routeChangeLogger) {
    return routeChangeLogger;
  }
  routeChangeLogger = getUrlChangeScenario(instrumentation).routeChange.create();
  return routeChangeLogger;
};

const getParamChangeLogger = (instrumentation) => {
  if (paramChangeLogger) {
    return paramChangeLogger;
  }
  paramChangeLogger = getUrlChangeScenario(instrumentation).paramChange.create();
  return paramChangeLogger;
};

const RouteChangeLoggerInternal = (props) => {
  const currentRoute = window.location.pathname.toLowerCase();
  const currentSearch = window.location.search.toLowerCase();


  if (previousRoute) {
    if (previousRoute !== currentRoute) {
      getRouteChangeLogger(props.instrumentation).trace(`${previousRoute} -> ${currentRoute}`);
    }
  } else {
    getRouteChangeLogger(props.instrumentation).trace(`initial route: ${currentRoute}`);
  }

  if (previousSearch) {
    if (previousSearch !== currentSearch) {
      getParamChangeLogger(props.instrumentation).trace(`${previousSearch} -> ${currentSearch}`);
    }
  } else {
    getParamChangeLogger(props.instrumentation).trace(`initial param: ${currentSearch}`);
  }

  previousRoute = currentRoute;
  previousSearch = currentSearch;
  return null;
};

RouteChangeLoggerInternal.propTypes = {
};

export const RouteChangeLogger = withRouter(withInstrumentation(React.memo(RouteChangeLoggerInternal)));
